package fr.frux.splash

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp

/**
 * Logo de tête de l'accueil en disposition compacte (#492), à la place du pictogramme provisoire.
 * Le disque reprend le fond crème du splash : la palette du logo est fixe et la couronne se perdrait
 * sur le fond sombre du thème. 160 dp par défaut, une taille posée par [modifier] l'emporte.
 */
@Composable
fun WelcomeLogo(modifier: Modifier = Modifier) {
    Box(
        modifier =
            modifier
                .size(160.dp)
                .clip(CircleShape)
                .background(FOND_SPLASH),
        contentAlignment = Alignment.Center,
    ) {
        FruxLogoMark(modifier = Modifier.fillMaxSize(LOGO_FRACTION))
    }
}

private const val LOGO_FRACTION = 0.7f
